import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-body-2 text-red pt-3" }

import { ref, nextTick } from 'vue';
import type { VForm } from 'vuetify/components';
import { useFormattable } from '@/common/composables/useFormattable';
import { CommonSettings } from '@/common/common-settings';
import * as Utils from '@/common/utils';
import { Media } from '@/store/models/media';

/** Props **/

export default /*@__PURE__*/_defineComponent({
  __name: 'AddMediaDialog',
  props: {
    titleType: { default: '画像' },
    acceptType: { default: '.png, .jpg, .jpeg' }
  },
  emits: ["onPushEnterBtn"],
  setup(__props: any, { expose: __expose, emit: __emit }) {



/** Emits **/
const emit = __emit;

/** Refs **/
const form = ref<VForm | null>(null);
const display = ref(false);
const title = ref('');
const file = ref<File | null>(null);
const { contractId, storeId, is2ndGenData } = useFormattable();

/** バリデーションルール */
const rules = {
  required: [(value: File[] | undefined): boolean | string => !value || value.length > 0 || '必須項目です。'],
  title: [
    (value: string): boolean | string => value !== '' || '必須項目です。',
    (value: string): boolean | string =>
      Utils.maxLength(value, Media.MAX_MEDIA_TITLE_LENGTH) ||
      `${Media.MAX_MEDIA_TITLE_LENGTH}文字以内で入力してください。`,
  ],
};

/** Methods **/
const open = (): void => {
  display.value = true;
};

/** ダイアログを閉じる */
const close = (): void => {
  title.value = '';
  file.value = null;
  display.value = false;
};

/** キャンセルボタン押下時 */
const onPushCancelBtn = (): void => {
  close();
};

/** 保存ボタン押下時 */
const onPushEnterBtn = async (): Promise<void> => {
  // DOMの更新を待つ
  await nextTick();

  const validation = await form.value?.validate();

  if (!validation?.valid || !file.value) {
    alert(validation?.errors[0]?.errorMessages?.[0] ?? `入力項目に不足または誤りがあります`);
    return;
  }

  const fileName = Utils.makeNewUuid();
  const extension = file.value ? file.value.name.split('.').pop() : '';

  emit('onPushEnterBtn', {
    title: title.value,
    src: Utils.getStorageFilePath({
      is2ndGenData: is2ndGenData.value,
      folderName: CommonSettings.STORAGE.MEDIA_IMAGES,
      contractId: contractId.value,
      storeId: storeId.value,
      fileName: `${fileName}.${extension}`,
    }),
    file: file.value,
  });
  close();
};

__expose({ open });

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: display.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((display).value = $event)),
    "max-width": "750px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "scroll-none" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-h5 font-weight-bold" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.titleType) + "登録 ", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, {
            style: {"height":"100%"},
            class: "py-6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_form, {
                ref_key: "form",
                ref: form
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { dense: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "3"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_subheader, { class: "text-black" }, {
                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                              _createTextVNode(" タイトル ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "8"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: title.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event)),
                            rules: rules.title,
                            variant: "outlined",
                            density: "compact"
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "3"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_subheader, { class: "text-black" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.titleType) + "ファイル ", 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "8"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_file_input, {
                            modelValue: file.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((file).value = $event)),
                            rules: rules.required,
                            accept: _ctx.acceptType,
                            label: "ファイルを選択",
                            variant: "solo-filled",
                            density: "compact",
                            "hide-details": "auto"
                          }, null, 8, ["modelValue", "rules", "accept"]),
                          _createElementVNode("p", _hoisted_1, _toDisplayString(`拡張子が「${_ctx.acceptType}」のファイルを指定してください`), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512)
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "4",
                    sm: "2",
                    offset: "4",
                    "offset-sm": "8",
                    class: "pt-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        block: "",
                        variant: "outlined",
                        onClick: onPushCancelBtn
                      }, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createTextVNode("閉じる")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "4",
                    sm: "2",
                    class: "pt-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        variant: "elevated",
                        block: "",
                        onClick: onPushEnterBtn
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createTextVNode("done")
                            ])),
                            _: 1
                          }),
                          _cache[6] || (_cache[6] = _createTextVNode("保存"))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})